module.exports = __webpack_public_path__ + "media/custom/images/img23-1c1593d7a3fe8c750d9228e61c514dc1.jpg";